module.exports = __webpack_public_path__ + "img/logbo-title.b25a8370.png";